/*
 * moves an element in an array from 'oldIndex' to 'newIndex'
 * 
 * arrayMove([ 'foo', 'bar', 'baz' ], 0, 1) ->  [ 'bar', 'foo', 'baz' ]
 */

module.exports = function arrayMove (array, oldIndex, newIndex) {
	const _array = [ ...array ]
	
	while (oldIndex < 0) {
		oldIndex += array.length;
	}
	
	while (newIndex < 0) {
			newIndex += _array.length;
	}
	
	if (newIndex >= _array.length) {
			var k = newIndex - _array.length + 1;
			while (k--) {
					_array.push(undefined);
			}
	}
	
	_array.splice(newIndex, 0, _array.splice(oldIndex, 1)[0]);
	
	return _array;
}
